const getPagename = (route, catalogId, asPath, overrideObj) => {
    const pagename = `${catalogId.toLocaleLowerCase()}::store::`;
    if (overrideObj) {
        return `${pagename}${overrideObj.pageName}`;
    }
    if (route.includes('/p/')) {
        return `${pagename}product page`;
    }
    if (route.includes('/c/')) {
        return `${pagename}category`;
    }
    if (route.includes('/cart')) {
        return `${pagename}basket page`;
    }
    if (route.includes('mini basket')) {
        return `${pagename}mini basket`;
    }
    if (route.includes('/help/')) {
        return `${pagename}help`;
    }
    if (route.includes('/search')) {
        return `${pagename}search`;
    }
    if (route.includes('/account/address')) {
        return `${pagename}address`;
    }
    if (route.includes('/account/order')) {
        return `${pagename}order`;
    }
    if (route.includes('/account/orders')) {
        return `${pagename}orders`;
    }
    if (route.includes('/account/settings')) {
        return `${pagename}settings`;
    }
    if (route.includes('/account/wishlist')) {
        return `${pagename}wishlist`;
    }
    if (route.includes('/user/forgot-password')) {
        return `${pagename}forgot_password`;
    }
    if (route.includes('/user/reset-password')) {
        return `${pagename}reset_password`;
    }
    if (route.includes('/user/login')) {
        return `${pagename}login`;
    }
    if (route.includes('/user/register')) {
        return `${pagename}register`;
    }
    if (route.includes('checkout/success')) {
        return `${pagename}booking confirmation`;
    }
    if (route.includes('checkout/thank-you')) {
        return `${pagename}booking confirmation`;
    }
    if (route.includes('checkout/failure')) {
        return `${pagename}booking failed`;
    }
    if (route.includes('checkout')) {
        return `${pagename}payment summary`;
    }
    if (route.includes('/posts') && asPath.includes('/about-us')) {
        return `${pagename}hub_articles`;
    }
    if (route.includes('/posts')) {
        return `${pagename}articles`;
    }
    return `${pagename}homepage`;
};
const getPageCategory = (route) => {
    if (route.includes('/p/')) {
        return 'store';
    }
    if (route.includes('/c/')) {
        return 'store';
    }
    if (route.includes('/cart')) {
        return 'checkout';
    }
    if (route.includes('mini basket')) {
        return 'checkout';
    }
    if (route.includes('checkout')) {
        return 'checkout';
    }
    if (route.includes('/help/')) {
        return 'help';
    }
    if (route.includes('/search')) {
        return 'store';
    }
    if (route.includes('/posts')) {
        return 'store';
    }
    if (route.includes('/account')) {
        return 'account';
    }
    if (route.includes('/user')) {
        return 'account';
    }
    return 'homepage';
};
const getPageType = (route, asPath) => {
    if (route.includes('/p/')) {
        return 'product page';
    }
    if (route.includes('/c/')) {
        return 'category';
    }
    if (route.includes('/cart')) {
        return 'basket page';
    }
    if (route.includes('mini basket')) {
        return 'basket page';
    }
    if (route.includes('/help/')) {
        return 'help';
    }
    if (route.includes('/search')) {
        return 'search';
    }
    if (route.includes('/account/address')) {
        return 'address';
    }
    if (route.includes('/account/order')) {
        return 'order';
    }
    if (route.includes('/account/orders')) {
        return 'orders';
    }
    if (route.includes('/account/settings')) {
        return 'settings';
    }
    if (route.includes('/account/wishlist')) {
        return 'wishlist';
    }
    if (route.includes('/user/forgot-password')) {
        return 'forgot_password';
    }
    if (route.includes('/user/reset-password')) {
        return 'reset_password';
    }
    if (route.includes('/user/register')) {
        return 'register';
    }
    if (route.includes('/user/login')) {
        return 'login';
    }
    if (route.includes('checkout/success')) {
        return 'booking confirmation';
    }
    if (route.includes('checkout/thank-you')) {
        return 'booking confirmation';
    }
    if (route.includes('checkout/failure')) {
        return 'booking failed';
    }
    if (route.includes('/posts') && asPath.includes('/about-us')) {
        return 'hub_articles';
    }
    if (route.includes('/posts')) {
        return 'articles';
    }
    if (route.includes('checkout')) {
        return 'payment summary';
    }
    return 'homepage';
};
const getVirtualPath = (route, asPath) => {
    if (route.includes('/p/')) {
        return '/product/';
    }
    if (route.includes('/c/')) {
        return '/category/';
    }
    if (route.includes('/cart')) {
        return '/cart';
    }
    if (route.includes('/checkout/failure')) {
        return '/order/failed_confirmation';
    }
    if (route.includes('/checkout/success')) {
        return '/order/confirmation';
    }
    if (route.includes('/checkout/thank-you')) {
        return '/order/confirmation';
    }
    if (route.includes('/help/')) {
        return '/help';
    }
    if (route.includes('/search')) {
        return '/search';
    }
    if (route.includes('/account/address')) {
        return 'account/address/';
    }
    if (route.includes('/account/order')) {
        return 'acccount/order/';
    }
    if (route.includes('/account/orders')) {
        return 'account/orders/';
    }
    if (route.includes('/account/settings')) {
        return 'account/settings/';
    }
    if (route.includes('/account/wishlist')) {
        return 'account/wishlist/';
    }
    if (route.includes('/user/forgot-password')) {
        return 'account/forgot_password/';
    }
    if (route.includes('/user/reset-password')) {
        return 'account/reset_password/';
    }
    if (route.includes('/user/register')) {
        return 'account/register/';
    }
    if (route.includes('/user/login')) {
        return 'account/login/';
    }
    if (route.includes('checkout')) {
        return '/order/summary';
    }
    if (route.includes('/posts') && asPath.includes('/about-us')) {
        return '/hub_articles/';
    }
    if (route.includes('/posts')) {
        return '/article/';
    }
    return '/homepage/';
};
const getItemListName = (route) => {
    if (route.includes('/c/')) {
        const urlSegmentsAfterCategory = route.match(/\/c\/([^/]+)(\/[^/?]+)?/);
        return urlSegmentsAfterCategory[2] ? 'sub-category' : 'category';
    }
    // having checkout and product page to be cross_sell for now
    if (route.includes('/p/')) {
        return '';
    }
    if (route.includes('cross sell')) {
        return `cross_sell`;
    }
    if (route.includes('/checkout')) {
        return `checkout`;
    }
    if (route.includes('/cart')) {
        return `basket`;
    }
    if (route.includes('mini basket')) {
        return `mini_basket`;
    }
    if (route.includes('/search')) {
        return `search_results`;
    }
    if (route.includes('/suggestions/')) {
        return `suggestions`;
    }
    return `homepage`;
};

export { getItemListName, getPageCategory, getPageType, getPagename, getVirtualPath };
//# sourceMappingURL=dataRouteFormat.js.map
